import type { EntityValidationRules } from "services/validationService";
import { computed, observable } from "mobx";

export const EmailValidationRules: EntityValidationRules<Contact> = {
  emailAddress: {
    isEmail: true,
  },
};

export const EmailConfirmationValidationRules: EntityValidationRules<Contact> = {
  _emailConfirmation: {
    equalWith: { property: "emailAddress" as const },
    isEmail: true,
  },
};

export const PhoneNumberValidationRules: EntityValidationRules<Contact> = {
  phoneNumber: { isPhoneNumber: true },
};

export default class Contact {
  @observable
  phoneNumber?: string;

  @observable
  smsNotificationEnabled = false;

  @observable
  emailAddress: string;

  @observable
  _emailConfirmation: string;

  @observable
  emailNotificationEnabled = false;

  @observable
  authCode?: string;

  @observable
  canBeChanged?: boolean;

  @computed
  get rules(): EntityValidationRules<Contact> {
    return {
      ...EmailValidationRules,
      ...EmailConfirmationValidationRules,
      ...(this.smsNotificationEnabled ? PhoneNumberValidationRules : {}),
    };
  }

  @computed
  get editRules(): EntityValidationRules<Contact> {
    return {
      ...EmailValidationRules,
      ...(this.smsNotificationEnabled ? PhoneNumberValidationRules : {}),
    };
  }
}

export const ContactValidationRules: EntityValidationRules<Contact> = {
  emailAddress: {
    isEmail: true,
  },
  _emailConfirmation: {
    equalWith: { property: "emailAddress" as const },
    isEmail: true,
  },
};

export const PhoneContactValidationRules: EntityValidationRules<Contact> = {
  emailAddress: { isEmail: true },
  phoneNumber: { isPhoneNumber: true },
};

export const SMSNotificationEnabledRules: EntityValidationRules<Contact> = {
  phoneNumber: { isPhoneNumber: true },
};

export type ContactEditationTriggerer = "licensePlateChange" | "validityChange" | "contactChange" | "receiptChange";
